import type { LeaveType } from '../timeOffs';

export enum TimeOffEditingMethod {
  MANUAL = 'MANUAL',
  UPLOAD = 'UPLOAD',
  INTEGRATION = 'INTEGRATION',
}

export type ClientSetupStatus = {
  timeOffEditingMethod: TimeOffEditingMethod;
  dateTimeFormat?: string;
};

export type ClientLeaveType = {
  id: string;
  leaveType: LeaveType;
  originalLeaveType: string;
};

export type GetClientSetupStatusResponse = ClientSetupStatus;

export type GetClientSettingsResponse = ClientSetupStatus;

export type GetClientLeaveTypesResponse = {
  items: ClientLeaveType[];
  total: number;
  page: number;
  size: number;
  pages: number;
};

export type CreateClientLeaveTypeRequest = Omit<ClientLeaveType, 'id'>;
